var schema ={
    email:  'required|email',
    otp: 'required|min:6',
    password: 'required|passRejex',
    confirmPassword: 'required|confirmed:@password',
    carrierCode: 'required',
    phone: 'required',
    userType: 'required',
    firstName: 'required|alpha_spaces|min:2',
    lastName: 'required|alpha_spaces|min:2',
    passcode: 'required|max:4',
    confirmPasscode: 'required|confirmed:@passcode',
};

export default schema;
